import { render, staticRenderFns } from "./LastMatchdayGamesWidget.vue?vue&type=template&id=28811530"
import script from "./LastMatchdayGamesWidget.vue?vue&type=script&lang=js"
export * from "./LastMatchdayGamesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports